export default __webpack_public_path__ + "img/x-purple.277dd54.svg";